import React from 'react';
import { renderProcessedText } from '../../utils/textRenderer';

interface FaqAnswersComponentProps {
  title: string;
  message: string;
}

const FaqAnswersComponent: React.FC<FaqAnswersComponentProps> = ({ title, message }) => {
  return (
    <div className="faq-answers-component">
      <div className="faq-answers-component__card">
        <div className="faq-answers-component__header">
         <h4 className="faq-answers-component__title">{renderProcessedText(title)}</h4>
        </div>
        <div className="faq-answers-component__content">
          <p className="faq-answers-component__message">{renderProcessedText(message)}</p>
        </div>
      </div>
    </div>
  );
};

export default FaqAnswersComponent;
